'use strict';

module.exports = require('./src/js/main');



//////////////////
// WEBPACK FOOTER
// /Volumes/MACOS-START/Outside/SITE Co-WORKING/ng/~/perfect-scrollbar/index.js
// module id = ../../../../perfect-scrollbar/index.js
// module chunks = 11